<template>
  <div>
    <el-card style="min-height: 45rem">
      <el-table :data="list" border>
        <el-table-column prop="id" label="编号"></el-table-column>
        <el-table-column prop="sort" label="排序"></el-table-column>
        <el-table-column prop="file" label="图片">
          <template #default="s">
            <img class="flex-def" :src="s.row.file | tomedia" style="height: 2rem;width: 2rem;border-radius: .2rem" alt="">
          </template>
        </el-table-column>
        <el-table-column prop="link" label="跳转链接"></el-table-column>
        <el-table-column label="操作" align="center">
          <template #header>
            <el-button @click="editFormBox=true" type="primary">添加轮播图</el-button>
          </template>
          <template #default="s">
            <el-button @click="editItem(s.row)" type="primary">编辑</el-button>
            <el-button @click="del(s.row)" type="danger">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog title="编辑轮播图" :visible.sync="editFormBox" @close="editFormClose">
        <el-form label-width="3rem" style="padding: 0 2rem">
          <el-form-item label="排序">
            <el-input-number v-model="form.sort"></el-input-number>
          </el-form-item>
          <el-form-item label="图片">
            <y_upload_img v-model="form.file"></y_upload_img>
          </el-form-item>
          <el-form-item label="链接">
            <y_choose_link v-model="form.link"></y_choose_link>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editFormBox = false">取 消</el-button>
          <el-button type="primary" @click="edit">确 定</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import y_upload_img from "@/components/y-form/y-upload/y_upload_img";
import y_choose_link from "@/components/shop/y_choose_link";
export default {
  name: "banner",
  components:{
    y_upload_img,
    y_choose_link
  },
  data() {
    return {
      list:[],
      form:{
        sort:0,
        file:"",
        link:""
      },
      editFormBox:false,
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    del(item){
      this.$u.api.shop.sys.bannerDel({id:item.id}).then(()=>{
        this.$message.success("操作成功");
        this.editFormBox = false;
        this.load();
      })
    },
    editItem(item){
      this.form = {...item};
      this.editFormBox = true;
    },
    editFormClose(){
      this.form = {
        sort:0,
        file:"",
        link:""
      }
      this.editFormBox = false;
    },
    load() {
      this.$u.api.shop.sys.bannerAll().then(res=>{
        this.list = res;
      })
    },
    edit(){
      this.$u.api.shop.sys.bannerEdit(this.form).then(()=>{
        this.$message.success("操作成功");
        this.editFormBox = false;
        this.load();
      })
    },
  }
}
</script>

<style scoped>

</style>